import { DEFAULT_APPLICATION_STATE } from './applications_initial'


export function applications(state = DEFAULT_APPLICATION_STATE, action) {
    switch (action.type) {
        case 'APPLICATIONS_CREATE_SUCCESS': {        
            return action.customer;
        }
        case 'APPLICATIONS_UPDATE_DATA':
        {
            var newstate = {
                ...state,                
                ...action.customer
                 }
            return Object.assign({}, state, newstate);
           }
      
        case 'APPLICATIONS_IS_LOADING':
            return Object.assign({}, state, 
            {
                ...state, 
                isFetching: action.isFetching
            } );

        default:
            return state;
    }
}
